import { AlertTriangle } from "lucide-react";

// Shown in place of the dashboard figures when a read failed. It carries no
// number on purpose: a figure that could not be read must not look like zero.
export function DashboardLoadError({ onRetry }: { onRetry: () => void }) {
  return (
    <div>
      <h1 style={{ marginBottom: "var(--spacing-sm)" }}>Commercial Dashboard</h1>
      <div
        className="card"
        role="alert"
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          padding: "4rem 2rem",
          marginTop: "2rem",
          gap: "0.75rem",
        }}
      >
        <AlertTriangle size={36} strokeWidth={1.5} style={{ color: "var(--color-error-text)" }} aria-hidden="true" />
        <h2 style={{ fontSize: "1rem", fontWeight: 600, color: "var(--text-primary)", margin: 0 }}>
          Could not load the dashboard figures
        </h2>
        <p style={{ color: "var(--text-secondary)", maxWidth: "460px", lineHeight: 1.6, margin: 0 }}>
          We could not read part of your data, so no totals are shown rather than totals that could be wrong.
          Check your connection and try again. If it keeps failing, tell the team.
        </p>
        {/* The global .btn shrinks to 22px tall on phones and animates every property, so the
            outline is mid-fade when focus lands. Size and transition are set here for this one action. */}
        <button
          type="button"
          className="btn btn-primary"
          onClick={onRetry}
          style={{
            marginTop: "0.75rem",
            minHeight: 44,
            minWidth: 44,
            padding: "0.5rem 1.5rem",
            fontSize: "0.875rem",
            transition: "background-color 150ms ease",
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}
